import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';

import * as fromApp from './../../store/app.reducers';
import * as fromPayment from './../store/payment.reducers';
import * as PaymentActions from './../store/payment.actions';
import * as fromUser from '../../user/store/user.reducers';
import {StripeSource} from 'stripe-angular';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.scss'],
    standalone: false
})
export class PaymentDetailsComponent implements OnInit, OnDestroy {

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService
  ) { }

  paymentState: Observable<fromPayment.State>;
  userState: Observable<fromUser.State>;
  routeSubscription: Subscription;
  id: number;
  loading: boolean;
  invalidError: any;
  paymentType: number;

  ngOnInit() {
    this.loading = false;
    this.paymentType = 1;
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = +params.id;
        this.store.dispatch(
          new PaymentActions.GetPrice(+params.id)
        );
      }
    );
    this.paymentState = this.store.select('payment');
    this.userState = this.store.select('user');
  }

  setPaymentType(type: number) {
    this.paymentType = type;
  }

  setPaymentLoader(value = true) {
    this.store.dispatch(
      new PaymentActions.SetPaymentLoader({
        name: 'pay',
        value: value
      })
    );
  }

  onPayment() {
    this.loading = true;
    this.store.dispatch(
      new PaymentActions.CreatePayment(this.id)
    );
  }

  onStripeInvalid( error: Error ) {
    console.log('Validation Error', error);
  }

  setStripeToken( token: stripe.Token ) {
    console.log('Stripe token', token);
    this.store.dispatch(
      new PaymentActions.CreatePaymentStripe({
        id: this.id,
        token: token.id
      })
    );
  }

  setStripeSource( source: StripeSource ) {
    console.log('Stripe source', source);
  }

  onStripeError( error: Error ) {
    console.error('Stripe error');
    this.notifierService.error(error.message);
    this.setPaymentLoader(false);
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

}
